// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 456) return "static/chunks/lottie-web-0612b101a1d7c2f4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "56cd88f438f1dc8b" + ".js";
};